module.exports = __webpack_public_path__ + "media/how_fastweb_works/press_header-4dd9bccb.png";